import updateTokenEmailSliceReducer from './updateTokenSendEmailSlice';
import tokenUpdate from './updateTokenSlice';
import emissionsReducer from './emissions';

export default {
  emissions: emissionsReducer,
  updateTokenEmailSliceReducer,
  tokenUpdate,
};
